/*
 * Name: Review Section
 * Desc:
 *
 */
import Link from "next/link"
import React from "react"
import Button from "@components/objects/Button/Button"
import ReviewSection from "./ReviewSection"
import * as styles from "./ReviewSection.module.scss"

const FormReview = ({ data, photos, handleChange, sectionSubmitting }) => (
  <div>
    <div className={styles.ReviewHeader}>
      <h1>Review your details</h1>
      <p>
        Below is an overview of your details. If there is anything you would like to change before
        sending to us, please navigate to the section you would like to edit above.
      </p>
      <div className={styles.reviewActions}>
        <div className={styles.terms}>
          <input
            id="termsandconditions"
            required
            onChange={(e) => handleChange(e, true)}
            name="termsAndConditions"
            type="checkbox"
          />
          <label htmlFor="termsandconditions">
            By registering your details and clicking FINAL SUBMIT you agree that you are a duly
            authorised officer or representative of the Supplier and you agree to be bound by the{" "}
            <Link href="/supplier-terms">
              <a>HOPP Supplier Terms and Conditions</a>
            </Link>{" "}
            and{" "}
            <Link href="/privacy-policy">
              <a>HOPP Privacy Policy</a>
            </Link>
            .
          </label>
        </div>

        <Button text="Final Submit" type="submit" onEnable={sectionSubmitting} />
      </div>
    </div>
    <ReviewSection data={data} photos={photos} />
  </div>
)

export default FormReview
